import { useRouteError } from 'react-router';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';
import { getErrorMessage } from 'lib/utils/common/getErrorMessage';

export const RouteError = () => {
  // const navigate = useNavigate();
  const error = useRouteError();

  const errorMessage = getErrorMessage(error);

  const handleClose = () => {
    window.location.reload();
    // navigate('/consultant');
  };

  // console.log('RouteError', error);

  return <ErrorModal onClose={handleClose} message={errorMessage} />;
};
